<template>
    <div>
        <div class="content-box">
            <div class="top-tool-bar mb6">
                <span class="check-all-btn width120" @click="checkAll('view')">全选</span>
                <span class="check-all-btn width120" @click="checkAll('edit')">全选</span>
            </div>
            <el-form ref="form" label-width="150px" class="form-wrap">
                <el-form-item :label="item.display_name+'：'" v-for="item in fieldsData" class="mb6">
                    <el-checkbox class="width120" v-model="item.checked" :disabled="item.disabled||isView" @change="checkView(item,$event)">查看</el-checkbox>
                    <el-checkbox class="width120" v-model="tag_action_ids_editable[item.name]" :disabled="notEditableFields.includes(item.name)||isView" @change="checkEdit(item,$event)">编辑</el-checkbox>
                </el-form-item>
            </el-form>
        </div>
        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div class="dialog-footer pt20 tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    export default {
        name: "TagFieldsConfig",
        props:{
            isView:{
                type: Boolean,
                default:false,
            },
            tagEditable:{
                type: Object,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            fields: {
                type: Array,
                required: true
            },
            cbs:{
                type:Object,
            },
        },
        data(){
            return {
                dialogVisible: false,
                fieldsData: [],
                oldData:[],
                curErrMsg:null,
                tag_action_ids_editable:{},
                notEditableFields:[],
            };
        },
        watch:{
            fields: {
                handler(fields) {
                    this.fieldsData = cloneDeep(fields||[]);
                    let pageTagEditable = (this.tagEditable[this.page.id]||"").split(',');
                    fields.forEach(item=>{
                        let config = JSON.parse(item.config||"{}")||{};
                        if(config.editable=='false'){
                            this.notEditableFields.push(item.name);
                        }
                        this.$set(this.tag_action_ids_editable,item.name,pageTagEditable.includes(item.id));
                    })
                },
                deep: true,
                immediate: true
            }
        },
        methods:{
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                let viewChecked = this.fieldsData.filter(item=>item.checked).map(item=>item.id);
                let editChecked = [];

                this.fieldsData.forEach(item=>{
                    if(this.tag_action_ids_editable[item.name]){
                        editChecked.push(item.id);
                    }
                });
                this.cbs.onSubmit(this.page,viewChecked,editChecked);
                this.handleClose();
            },
            checkAll(type){
                if(this.isView) return false;
                if(type=='view'){
                    this.fieldsData.forEach(item=>{
                        if(!item.disabled){
                            item.checked = true;
                        }
                    })
                }else if(type=='edit'){
                    this.fieldsData.forEach(item=>{
                        if(!this.notEditableFields.includes(item.name)){
                            this.tag_action_ids_editable[item.name] = true;
                            if(!item.checked){
                                item.checked = true;
                            }
                        }
                    })
                }
            },
            checkEdit(item,val){
                if(val===true&&item.checked===false){
                    item.checked = true;
                }
            },
            checkView(item,val){
                if(val===false&&this.tag_action_ids_editable[item.name]===true){
                    this.tag_action_ids_editable[item.name] = false;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .top-tool-bar{
        padding-left: 150px;
        .check-all-btn{
            display: inline-block;
            text-indent: 10px;
            cursor: pointer;
        }
    }
    .form-wrap{
        max-height: 300px;
        overflow-y: auto;
    }
    .width120{
        width: 150px;
    }
    .mb6{
        margin-bottom: 6px!important;
    }
</style>
